import { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate, useLocation, Link } from "react-router-dom";
import api from "@/lib/api";
import Logo from "@/components/common/Logo";
import { Search, ArrowLeft } from "lucide-react";

export default function DocsLayout() {
  const [pages, setPages] = useState([]);
  const [q, setQ] = useState("");
  const loc = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    api.get("/api/docs/pages").then(({ data }) => setPages(data)).catch(() => {});
  }, []);

  // Group by section
  const grouped = pages.reduce((acc, p) => {
    if (q && !p.title.toLowerCase().includes(q.toLowerCase()) && !p.section.toLowerCase().includes(q.toLowerCase())) return acc;
    acc[p.section] = acc[p.section] || [];
    acc[p.section].push(p);
    return acc;
  }, {});

  return (
    <div className="min-h-screen flex bg-[var(--bg)]">
      <aside className="w-72 border-r border-[var(--border)] flex flex-col">
        <div className="p-5 border-b border-[var(--border)]">
          <Link to="/dashboard" className="flex items-center gap-2 text-[var(--text-2)] hover:text-[var(--gold)] text-xs mb-3" data-testid="docs-back-to-admin">
            <ArrowLeft size={12}/> Back to admin
          </Link>
          <div className="flex items-center gap-2.5">
            <Logo size={32}/>
            <div className="leading-none">
              <div className="font-semibold text-sm tracking-tight">CoreBridge</div>
              <div className="text-[9px] text-[var(--text-3)] uppercase tracking-[0.18em] mt-0.5">Developer Portal</div>
            </div>
          </div>
          <div className="mt-4 relative">
            <Search size={13} className="absolute left-2 top-2.5 text-[var(--text-3)]"/>
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search docs…"
              className="w-full pl-7 pr-2 py-1.5 bg-[var(--surface-2)] border border-[var(--border)] rounded text-xs focus:outline-none focus:border-[var(--gold)]"
              data-testid="docs-search"
            />
          </div>
        </div>
        <nav className="flex-1 overflow-y-auto py-3 px-3 space-y-0.5">
          <NavLink to="/docs" end className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} data-testid="nav-doc-overview">
            Home
          </NavLink>
          {Object.keys(grouped).map(section => (
            <div key={section} className="mt-3">
              <div className="text-[10px] uppercase tracking-widest text-[var(--text-3)] px-3 mb-1">{section}</div>
              {grouped[section].map(p => (
                <NavLink
                  key={p.slug}
                  to={`/docs/${p.slug}`}
                  className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                  data-testid={`nav-doc-${p.slug}`}
                >
                  {p.title}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
      </aside>
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
